import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import { useTranslation } from "../../i18n/TranslationProvider";
import { translateOr, toLegacyLanguage } from "../../i18n/translateData";

import Sallie from "../Sallie";
import SubmitButton from "../StyledComponents/SubmitButton";
import LoadingSpinner from "../LoadingSpinner";
import SallieSVG from "../../images/sallie.svg";
import SadSallie from "../../images/Sallie-Oops.png";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import {
  checkEmailToken,
  getProviderTokenInformation,
  getInviterInfo,
  sendConfirmEmail,
  deleteEmailToken,
  creatConnection,
} from "../../api/helpReq";

const EmailConfirmForExistingProvider = ({ setOnboardingPercent, user }) => {
  const location = useLocation();
  const { t, language } = useTranslation();
  const history = useHistory();
  const url = new URLSearchParams(location.search);
  const token = url.get("token");
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [userType, setUserType] = useState(null);
  const [patientEmail, setPatientEmail] = useState(null);
  const [success, setSuccess] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    setOnboardingPercent(10);
    if (token) {
      getInviterInfo({ token })
        .then((res) => {
          const { data } = res;
          setFirstName(data.first_name);
          setLastName(data.last_name);
          setUserType(data.user_type);
          setPatientEmail(data.patient_email);
          setLoading(false);
        })
        .catch((err) => {
          console.error(err);
          setError(true); // Set the error state to true
          setLoading(false);
        });
    }
  }, []);

  const reSendEmail = () => {
    const { firstName, lastName, email } = user;
    sendConfirmEmail({
      email: email,
      name: firstName + " " + lastName,
      // Backend still expects "english"/"spanish" until the language-code migration
      language: toLegacyLanguage(language),
    });
    history.push("/Verification/EmailSent");
  };

  const clickHandlerLogin = async () => {
    history.push("/");
  };

  const clickHandler = async () => {
    try {
      setSubmitting(true);
      creatConnection({ token })
        .then((res) => {
          setSubmitting(false);
          setSuccess(true);
        })
        .catch((err) => {
          console.error(err);
          history.push("/oops");
        });
    } catch (err) {
      setSubmitting(false);
      history.push("/oops");
    }
  };

  // userType comes from the DB ("patient"/"caregiver"); translate it for display
  const userTypeLabel = translateOr(t, `common.userType.${userType}`, userType);
  let sallieMsg = t("onboarding.existingProvider.sallie", {
    userType: userTypeLabel,
    name: `${firstName} ${lastName}`,
    email: patientEmail,
  });
  let errorMsg = t("onboarding.existingProvider.error");

  let img = SallieSVG;

  return (
    <>
      <div className="d-flex justify-content-center">
        <h4 className="mt-4 mb-4">{t("onboarding.existingProvider.header")}</h4>
      </div>
      {loading ? (
        <LoadingSpinner />
      ) : error ? (
        <>
          <Sallie text={errorMsg} sad="true" />
          {/* <div className="error-message required" style={{ textAlign: 'right' }}>{errorMsg}</div> */}
          <SubmitButton disabled={submitting} onClick={reSendEmail}>
            {t("onboarding.emailConfirm.resendButton")}
          </SubmitButton>
        </>
      ) : (
        <>
          <Row>
            <Col
              md={2}
              style={{ minWidth: "125px" }}
              className="d-flex align-items-center justify-content-center"
            >
              <img
                style={{ maxWidth: "100%", maxHeight: "100%" }}
                src={img}
                alt={t("common.sallieAlt")}
              />
            </Col>
            <Col className="p-0" style={{ maxWidth: "70%" }}>
              <div className="sallie" style={{ fontSize: "1.3rem" }}>
                {sallieMsg}
              </div>
            </Col>
          </Row>
          {success === false ? (
            <SubmitButton
              style={{ marginRight: "13%", fontSize: "1.4rem" }}
              disabled={submitting}
              onClick={clickHandler}
            >
              {t("onboarding.confirm")}
            </SubmitButton>
          ) : (
            <>
              <h5 className="d-flex justify-content-center">
                {t("onboarding.existingProvider.success")}
              </h5>
              <SubmitButton
                style={{ marginRight: "13%", fontSize: "1.4rem" }}
                disabled={submitting}
                onClick={clickHandlerLogin}
              >
                {t("onboarding.login")}
              </SubmitButton>
            </>
          )}
        </>
      )}
    </>
  );
};

export default EmailConfirmForExistingProvider;